import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Slideshow.svg",
  "use": "Slideshow.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Slideshow.svg\"><path d=\"M56.0208,42.0208a2,2,0,0,1-2,2h-20V45.298L46.012,52.2887a2.0108,2.0108,0,0,1,.725,2.7322,1.97,1.97,0,0,1-2.7056.7319L34.0208,49.9169v4.1039a2,2,0,0,1-4,0v-4.104L20.01,55.7528a1.97,1.97,0,0,1-2.7056-.7319,2.0108,2.0108,0,0,1,.7249-2.7322L30.0208,45.298V44.0208h-20a2,2,0,0,1,0-4v-24a2,2,0,0,1,0-4h20v-2a2,2,0,0,1,4,0v2h20a2,2,0,0,1,0,4v24A2,2,0,0,1,56.0208,42.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol